import * as Sentry from "@sentry/react-native";
import * as SecureStore from "expo-secure-store";

import { DiagnosticStatus } from "@/schemas/app/diagnostic";
import { LAST_LOG_TIME_KEY, THROTTLE_DURATION } from "@/hooks/device";

/**
 * Interface for log time information
 */
export interface LogTimeInfo {
  timestamp: number | null;
  formattedTime: string;
  status: DiagnosticStatus;
  canLogAgain: boolean;
}

export async function getLastLogTime(): Promise<LogTimeInfo> {
  const result: LogTimeInfo = {
    timestamp: null,
    formattedTime: "Never",
    status: DiagnosticStatus.WARNING,
    canLogAgain: true,
  };

  try {
    const lastLogTimeStr = await SecureStore.getItemAsync(LAST_LOG_TIME_KEY);

    if (lastLogTimeStr) {
      const timestamp = parseInt(lastLogTimeStr, 10);
      if (!isNaN(timestamp)) {
        result.timestamp = timestamp;
        result.formattedTime = new Date(timestamp).toLocaleString();
        result.status = DiagnosticStatus.OK;

        // Check if enough time has passed since the last log
        const currentTime = Date.now();
        result.canLogAgain = currentTime - timestamp >= THROTTLE_DURATION;
      }
    }
  } catch (error) {
    result.formattedTime = "Error reading log time";
    result.status = DiagnosticStatus.ERROR;
    result.canLogAgain = true; // Default to allowing logs on error
    Sentry.captureMessage("Error retrieving device log time", {
      extra: { error },
    });
  }

  return result;
}
